import React, { useState, useEffect } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../Assets/Homeeframes/Homeeframes Liner (1).png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Projects", path: "/#projects" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const Navbar = ({ isDarkMode, toggleTheme }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (path) => {
    setIsMobileMenuOpen(false);
    if (path.startsWith("/#")) {
      const sectionId = path.replace("/#", "");
      if (location.pathname === "/") {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(() => {
          const el = document.getElementById(sectionId);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    } else {
      navigate(path);
    }
  };

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    if (path.startsWith("/#")) return location.pathname === "/";
    return location.pathname === path;
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
          ? isDarkMode
            ? "bg-[#111111]/90 backdrop-blur-md shadow-lg"
            : "bg-white/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => navigate("/")} className="flex items-center gap-2">
          {/* <img src={Logo} alt="Homeeframes" className="h-8 object-contain" /> */}
        </button>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.path)}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 relative group ${isActive(item.path)
                  ? isDarkMode
                    ? "text-[#FEF200]"
                    : "text-black"
                  : isDarkMode
                    ? "text-gray-400 hover:text-white"
                    : "text-gray-500 hover:text-black"
                }`}
            >
              {item.label}
              {/* Active underline */}
              <span
                className={`absolute -bottom-1 left-0 h-[2px] rounded-full transition-all duration-300 ${isActive(item.path) ? "w-full" : "w-0 group-hover:w-full"
                  } ${isDarkMode ? "bg-[#FEF200]" : "bg-black"}`}
              />
            </button>
          ))}
        </div>

        {/* Right Controls */}
        <div className="flex items-center gap-3">

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-full ${isDarkMode ? "text-white" : "text-black"
              }`}
          >
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isMobileMenuOpen && (
        <div
          className={`md:hidden px-6 pb-6 flex flex-col gap-1 border-t ${isDarkMode
              ? "bg-[#111111] border-gray-800"
              : "bg-white border-gray-100"
            }`}
        >
          {navLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.path)}
              className={`text-sm font-medium py-3 text-left border-b flex items-center justify-between transition-colors ${isActive(item.path)
                  ? isDarkMode
                    ? "text-[#FEF200] border-gray-800"
                    : "text-black border-gray-100"
                  : isDarkMode
                    ? "text-gray-400 border-gray-800 hover:text-white"
                    : "text-gray-500 border-gray-100 hover:text-black"
                }`}
            >
              {item.label}
              {isActive(item.path) && (
                <span
                  className={`w-1.5 h-1.5 rounded-full ${isDarkMode ? "bg-[#FEF200]" : "bg-black"
                    }`}
                />
              )}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
